/* Hausono: kortingsbalk in het mandje schuift soepel naar de nieuwe stand.
   De eindstand komt altijd uit de server (style="width:…"); we bewaren die als data-target,
   laten de balk vanaf de vorige stand glijden en zetten hem na afloop gegarandeerd op de eindstand. */
(function () {
  if (window.hsBarAnim) return; window.hsBarAnim = true;
  var last = null;
  function run() {
    document.querySelectorAll('.cart-drawer .hs-cartbar__fill').forEach(function (bar) {
      if (bar.dataset.target) return;
      var t = parseFloat(bar.style.width) || 0;
      bar.dataset.target = t;
      var from = last === null ? t : last;
      last = t;
      if (Math.abs(from - t) < 0.5) return;
      bar.style.transition = 'none';
      bar.style.width = from + '%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.style.transition = 'width 500ms ease';
          bar.style.width = t + '%';
        });
      });
      setTimeout(function () { bar.style.width = t + '%'; }, 650);
    });
  }
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();
